import React from 'react';
import { Link, useLocation } from "react-router-dom";
import logo from '../../static/landing/Logo.svg';
import MobileMenu from '../../static/landing/whitemenu.svg';
import "../../styles/LandingNavbar.css";

export default function LandingNavbar({ loggedIn, handleMobileActive }) {
    const location = useLocation();
    const noTabs = ["/login", "/register", "/resetpassword", "/newpassword", "/passwordsaved"];
    const noLogin = ["/login", "/password", "/resetpassword", "/newpassword", "/passwordsaved"];

    return (
        <nav className="LandingNavbar">
            <Link to="/" className="Navbar-Logo">
                <img 
                src={logo} 
                alt="Salewave Logo"/>
            </Link>
            {
                !noTabs.find(path => path === location.pathname) && 
                <ul className="Navbar-Tabs">
                    <li><Link to={{
                        pathname: "/",
                        state: {
                            goToFeatures: true
                        }}}>Features</Link></li>
                    <li><Link to="/pricing">Pricing</Link></li>
                    <li><Link to="/faq">FAQ</Link></li>
                </ul>
            }
            <div>
            {
                !loggedIn && !noLogin.find(path => path === location.pathname) &&
                <Link
                to="/login"
                className="Navbar-Login" 
                >Login</Link>
            }
            {
                !loggedIn && location.pathname !== "/register" &&
                <Link
                to="/register"
                className="Navbar-GetAccess"
                >Get Access</Link>
            }
            {
                loggedIn &&
                <Link
                to="/connectdepop"
                className="Navbar-GetAccess"
                >Dashboard</Link>
            }
            </div>
            <img 
            onClick={handleMobileActive}
            className="mobile-menu-button"
            src={MobileMenu} 
            alt="Menu"/>

        </nav>
    )
}